import { axiosInstance } from '../common/api';

export const deleteAccount = () => {
  const url = `/auth/deleteAccount`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
